// Card.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faIconName } from '@fortawesome/free-solid-svg-icons';
// import 'bootstrap/dist/css/bootstrap.min.css';

const InsuranceCard = ({ iconName, name }) => {
  return (
    <div className="col-lg-2 col-md-4 col-sm-6 mb-4 ">
      <div className="card insurance-card">
        <div className="card-body text-center text-white">
          <div className="icon insurance-icon">
            <FontAwesomeIcon icon={iconName} size="2x" />
          </div>
          <p className="card-title lh-lg text-center mt-3">{name}</p>
        </div>
      </div>
    </div>
  );
};

export default InsuranceCard;
